import React from 'react';
import {createRoot} from 'react-dom/client';
import GcInputPassword from './GcInputPassword'

const GcInputPasswordRoot = (props) => {
    return <GcInputPassword {...props} />;
}

export default GcInputPasswordRoot;

if(typeof window.GcInputPasswordRoots == 'undefined') {
    window.GcInputPasswordRoots = {};
}

// MOUNT/UNMOUNT OK

window.GcInputPasswordRoot = function(sectionTag = 'global'){
    let allElts = document.querySelectorAll('[data-react="gc-input-password"]');
    for (const element of allElts) {
        let uniqueId = element.dataset.windowId || sectionTag;
        let attr = {};

        let show_attr = element.getAttribute('show');
        element.removeAttribute('show');
        attr.show = (show_attr != null && show_attr !=="false");

        let refresh_attr = element.getAttribute('refresh');
        attr.refresh = (refresh_attr != null && refresh_attr !=="false");
        element.removeAttribute('refresh');

        let required_attr = element.getAttribute('required');
        attr.required = (required_attr != null && required_attr !=="false");
        element.removeAttribute('required');

        attr.placeholder = element.getAttribute('placeholder');
        element.removeAttribute('placeholder');

        attr.name = element.getAttribute('name');
        element.removeAttribute('name');

        attr.id = element.getAttribute('id');
        element.removeAttribute('id');

        const root = createRoot(element);
        root.render(<GcInputPasswordRoot {...attr} />);
        
        window.GcInputPasswordRoots[uniqueId] = root;
    }
}